import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useEffect } from "react";
import { useNavigate } from "react-router";


const Index = () => {

	const { instance, accounts } = useMsal();

	const isAuthenticated = useIsAuthenticated();
	const navigate = useNavigate();

	/** Use Effect Hook for inital call */
	useEffect(() => {

		/* Check if user is already authenticated by MSAL */
		if (isAuthenticated) {
			/* User is already authenticated */
			navigate("/admin/claims");
		}

		if (accounts.length === 1) {
			/* Try to login user silently */
			instance.acquireTokenSilent({ scopes: ["api://UnitCostsAPI/access_as_user"] })
				.then(silentResponse => {
					/* SSO Successfully */
					instance.setActiveAccount(silentResponse.account);
					navigate("/admin/claims");
				})
				.catch(error => {
					/* Check if error indiciates that interaction is required */
					if (!(error instanceof InteractionRequiredAuthError)) {
						navigate("/admin/login");
					}
				})
		}
		else {
			navigate("/admin/login"); // Interaction is needed, redirect to Login Site ...
		}
	}, [])

	return (
		<div>
		</div>
	)
}

export default Index;